import { capitalize, startCase } from 'lodash'
import { IssuanceType } from '~/types/gql/generated/graphql'

/**
 * If we provide a separator, it will be removed by the startCase method, so we must call capitalize instead
 * /! Which will only make the first word upper case
 * @param value
 * @param separator
 */
export function humanizeEnum<T extends string>(value?: T | null, separator?: string) {
  const _value = (value || '').replaceAll('_', separator || ' ').toLowerCase()
  if (separator) {
    return capitalize(_value)
  }
  return startCase(_value)
}

/**
 * Format a DealType for display in Title Case (e.g. "Single Asset", "Feeder Fund")
 */
export function fmtDealType(value?: string | null): string {
  if (!value)
    return ''
  return humanizeEnum(value)
}

/**
 * Format an IssuanceType for display:
 * - ISIN and OTC are displayed in uppercase
 */
export function fmtIssuanceType(value?: string | null): string {
  if (!value)
    return ''
  if (value === IssuanceType.Isin)
    return 'ISIN'
  if (value === IssuanceType.Otc)
    return 'OTC'
  return humanizeEnum(value)
}
